import {
  UseQueryResult,
  useQuery,
  UseQueryOptions,
} from '@tanstack/react-query';
import { QueryFetchFunction, QueryTransformer } from 'common/helpers/common';
import {
  ApiError,
  ApiResult,
  ExtendedApiResult,
} from 'common/repositories/common.model';

import {
  getChequeGirosInput,
  getChequeGiroInput,
  ChequeGiroLiteModel,
  ChequeGiroModel,
} from './model';

export function useGetChequeGiros(
  input?: getChequeGirosInput,
  options?: UseQueryOptions<ExtendedApiResult<ChequeGiroLiteModel[]>, ApiError>,
): UseQueryResult<ExtendedApiResult<ChequeGiroLiteModel[]>, ApiError> {
  return QueryTransformer(
    useQuery(
      options?.queryKey ?? ['getChequeGiros', input?.params],
      () =>
        QueryFetchFunction({
          url: 'cheque-giros',
          params: input?.params,
        }),
      options,
    ),
    ChequeGiroLiteModel,
  );
}

export function useGetChequeGiro(
  input?: getChequeGiroInput,
  options?: UseQueryOptions<ApiResult<ChequeGiroModel>, ApiError>,
): UseQueryResult<ApiResult<ChequeGiroModel>, ApiError> {
  return QueryTransformer(
    useQuery(
      options?.queryKey ?? ['getChequeGiro', input?.id],
      () => QueryFetchFunction({ url: `cheque-giros/${input?.id}` }),
      options,
    ),
    ChequeGiroModel,
  );
}

export function getChequeGirosKey(input?: getChequeGirosInput) {
  return ['getChequeGiros', input?.params];
}

export function getChequeGiroKey(input?: getChequeGiroInput) {
  return ['getChequeGiro', input?.id];
}
